<template>
  <!-- Selector tipo dropdown REUTILIZABLE (chrome del visor). Le pasas:
         · options: [{ value, label, color?, icon? }]  (color → swatch, icon → b-icon)
         · value:   el valor seleccionado (resalta su item)
       y emite:
         · epc-select(value)        al elegir una opción
         · epc-active-change(open)  al abrir/cerrar (para refrescar datos o rotar un chevron)
       El disparador es un slot `#trigger` (recibe { active }) para que el host
       controle su aspecto. Apoyado en Buefy b-dropdown (click-fuera, posición,
       cierre) y estilado a marca; el contenido SIEMPRE con padding del borde. -->
  <b-dropdown
    :value="value"
    :position="position"
    :mobile-modal="false"
    aria-role="list"
    class="epc-select-dropdown w-full"
    @change="(v) => $emit('epc-select', v)"
    @active-change="(open) => $emit('epc-active-change', open)"
  >
    <template #trigger="{ active }">
      <slot name="trigger" :active="active"></slot>
    </template>

    <b-dropdown-item
      v-for="opt in options"
      :key="opt.value === null || opt.value === undefined ? '__null__' : opt.value"
      :value="opt.value"
      aria-role="listitem"
    >
      <div class="flex items-center gap-2.5">
        <span v-if="opt.icon"
          class="w-3.5 h-3.5 flex-shrink-0 flex items-center justify-center text-gray-400">
          <b-icon pack="fas" :icon="opt.icon" size="is-small" />
        </span>
        <span v-else
          class="w-3.5 h-3.5 rounded-[4px] flex-shrink-0 ring-1 ring-inset ring-black/10 shadow-sm"
          :style="{ backgroundColor: opt.color || 'transparent' }"></span>
        <span class="flex-1 min-w-0 truncate" :title="opt.label">{{ opt.label }}</span>
      </div>
    </b-dropdown-item>

    <p v-if="!options.length && emptyText" class="px-3 py-3 text-[13px] text-gray-400 text-center">
      {{ emptyText }}
    </p>
  </b-dropdown>
</template>

<script>
export default {
  name: "WidgetSelectDropdown",

  props: {
    // Valor seleccionado (resalta su item). null = ninguno / opción "todas".
    value: { type: [String, Number, Object], default: null },
    // Opciones: [{ value, label, color?, icon? }].
    options: { type: Array, default: () => [] },
    // Posición del menú (Buefy): is-top-left | is-top-right | is-bottom-left | is-bottom-right.
    position: { type: String, default: "is-bottom-left" },
    // Texto cuando no hay opciones (opcional).
    emptyText: { type: String, default: "" },
  },
}
</script>

<style scoped>
/* Overrides mínimos de Buefy al azul de marca. El contenido SIEMPRE con padding
   del borde (el menú nunca pega los items al borde). */
.epc-select-dropdown :deep(.dropdown-menu) {
  min-width: 240px;
}

.epc-select-dropdown :deep(.dropdown-content) {
  padding: 5px;
  border-radius: 12px;
  border: 1px solid #e9e9ef;
  box-shadow: 0 10px 28px rgba(17, 24, 39, 0.18), 0 3px 8px rgba(17, 24, 39, 0.12);
  max-height: 320px;
  overflow-y: auto;
}

.epc-select-dropdown :deep(.dropdown-item) {
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 13px;
  color: #374151;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.epc-select-dropdown :deep(.dropdown-item:hover) {
  background-color: #f4f4f6;
  color: #374151;
}

.epc-select-dropdown :deep(.dropdown-item.is-active) {
  background-color: #eef3fb;
  color: #2f5aad;
  font-weight: 600;
}
</style>
